<template>
  <v-chart class="chart" :option="option" />
</template>
<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart } from "echarts/charts";

import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
} from "echarts/components";
use([
  CanvasRenderer,
  BarChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
]);

import { getAccidentsByType } from "@/api/api.js";

export default {
  components: {},
  data() {
    return {
      timer: 0,
      option: {
        height: 300,
        tooltip: {},
        legend: {},
        grid: {
          x: 40,
          y: 20,
          x2: 40,
          y2: 20
        },
        xAxis: { max: 30, show: false },
        yAxis: {
          data: ["其他", "水灾", "道路", "人员", "火灾"],
          axisTick: false,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#fff",
              fontSize: "15",
              fontWeight: 'bold'
            },
          },
        },
        series: [
          {
            data: [1, 5, 4, 2, 10],
            type: "bar",
            label: {
              show: true,
              position: "right",
              color: "#fff",
            },
            showBackground: true,
            backgroundStyle: {
              color: "rgba(132, 178, 197, 0.3)",
              borderRadius: [15, 15, 15, 15],
            },
            itemStyle: {
              normal: {
                label: {
                  show: true
                }
              },
              borderRadius: [15, 15, 15, 15],
            },
          },
        ],
      },
    };
  },
  methods: {
    getData() {
      getAccidentsByType().then((res) => {
        this.option.yAxis.data = res.data.data.map((item) => {
          return item.name
        })
        this.option.series[0].data = res.data.data.map((item) => {
          return item.num
        })
      });
    },
  },
  mounted() {
    this.getData()
    this.timer = setInterval(this.getData, 10000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
};
</script>
<style scoped></style>
